import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/announcement_rol/`, data);
};

const get = async (id) => {
  return await httpClient.get(`/announcement_rol/${id}/`);
};

const getCounters = async (id) => {
  return await httpClient.get(`/announcement_rol/${id}/counters/`);
};

const put = async (id, data) => {
  return await httpClient.put(`/announcement_rol/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/announcement_rol/${id}`);
};

const ajaxTable = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(
    query,
    page,
    pageSize,
    search,
    sortBy,
    exportCSV,
  );

  return await httpClient.get(
    exportCSV ? '/announcement_rol/export' : '/announcement_rol/',
    params,
  );
};

const postPlace = async (data) => {
  return await httpClient.post(`/announcement_rol_place/`, data);
};

const removePlace = async (id) => {
  return await httpClient.delete(`/announcement_rol_place/${id}/`);
};

const placeTable = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(
    query,
    page,
    pageSize,
    search,
    sortBy,
    exportCSV,
  );

  return await httpClient.get(
    exportCSV ? '/announcement_rol_place/export' : '/announcement_rol_place/',
    params,
  );
};

export {
  post,
  get,
  getCounters,
  put,
  remove,
  ajaxTable,
  postPlace,
  removePlace,
  placeTable,
};
